import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import '@/modules/carousel/carousel.css';

export default class RelatedProductsCarousel {
    constructor(el) {
        if (!el.querySelector('.swiper')) return;
        this.el = el;
        this.instance = null;

        const breakpoint = window.matchMedia('(min-width: 1024px)');
        
        if (!breakpoint.matches) {
            this.init();
        } else {
            this.removeSwiperStyling();
        }

        breakpoint.addEventListener('change', e => {
            if (e.matches) {
                this.destroy();
            } else {
                this.init();
            }
        });
    }

    init () {
        this.addSwiperStyling();

        this.instance = new Swiper(this.el.querySelector('.swiper'), {
            modules: [Navigation, Scrollbar],
            slidesPerView: 1.1,
            spaceBetween: 20,
            navigation: {
                nextEl: this.el.querySelector('.js-swiper-custom-button-next'),
                prevEl: this.el.querySelector('.js-swiper-custom-button-prev')
            },
            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
                draggable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.1
                }
            }
        });
    }

    destroy () {
        this.instance.destroy(true, true);

        this.removeSwiperStyling();

        this.instance = null;
    }

    addSwiperStyling () {
        /**
         * Adds `swiper` CSS classes to HTML structure.
         */
        this.el.querySelector('.js-swiper').classList.add('swiper');
        this.el.querySelector('.js-swiper-wrapper').classList.add('swiper-wrapper');
        [...this.el.querySelectorAll('.js-swiper-slide')].forEach(slide => slide.classList.add('swiper-slide'));
    }

    removeSwiperStyling () {
        /**
         * Removes `swiper` CSS classes from HTML structure.
         */
        this.el.querySelector('.js-swiper').classList.remove('swiper');
        this.el.querySelector('.js-swiper-wrapper').classList.remove('swiper-wrapper');
        [...this.el.querySelectorAll('.js-swiper-slide')].forEach(slide => slide.classList.remove('swiper-slide'));
    }
}
